"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PermissionMixin = void 0;

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.function.name");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vue = _interopRequireDefault(require("vue"));

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _helper = require("@/services/helper/helper.service");

var _sidebar = require("@/components/sidebar/sidebar.constants");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var helper = new _helper.Helper();

var PermissionMixin = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(PermissionMixin, _Vue);

  var _super = _createSuper(PermissionMixin);

  function PermissionMixin() {
    (0, _classCallCheck2.default)(this, PermissionMixin);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(PermissionMixin, [{
    key: "isRouteViewOnly",
    get: function get() {
      var isAdmin = helper.get(this.$userInformation, 'isAdmin', false);
      var permissionList = helper.get(this.$userInformation, 'user.permission', []);
      var isModify = false;
      var isAccess = false;

      if (permissionList.length > 0) {
        var planningToolAccess = permissionList.filter(function (i) {
          return i.Value === '0900';
        });

        if (planningToolAccess.length) {
          isModify = Boolean(planningToolAccess[0]['Modify']);
          isAccess = Boolean(planningToolAccess[0]['Access']);
        }
      }
      /*const isModifyAllowed = (
        isAdmin ||
        isModify ||
        !(!isModify && isAccess)
      );
           return !isModifyAllowed;*/


      if (!isAdmin && !isAccess && !isModify) {
        this.logOutUser();
      }

      return !isAdmin && !isModify && isAccess;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      if (this.$router.currentRoute.name && this.$router.currentRoute.meta.permission && !this.hasPermission(this.$router.currentRoute.name, this.$router.currentRoute.meta.permission)) {
        this.$router.push({
          name: 'unauthorized'
        });
      }
    }
  }, {
    key: "hasPermission",
    value: function hasPermission() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var permissionList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (this.$isAdmin) {
        return true;
      }

      if (!name || !this.$userData || !this.$userData.permission) {
        return false;
      }

      if (permissionList.length === 0) {
        return this.isRouteViewOnly ? _sidebar.DEFAULT_VIEW_ONLY_ROUTES.includes(name) : true;
      }

      return this.isRouteViewOnly ? this.$userData.permission.some(function (plist) {
        return permissionList.includes(plist);
      }) && _sidebar.DEFAULT_VIEW_ONLY_ROUTES.includes(name) : this.$userData.permission.some(function (plist) {
        return permissionList.includes(plist);
      });
    }
  }, {
    key: "logOutUser",
    value: function logOutUser() {
      window.localStorage.setItem('isLoggedOut', '1');
      window.localStorage.setItem('rld', '1');
      this.$logOutUser();
      this.$router.push({
        path: '/'
      });
    }
  }]);
  return PermissionMixin;
}(_vue.default);

exports.PermissionMixin = PermissionMixin;
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userInformation', {
  namespace: 'authentication'
})], PermissionMixin.prototype, "$userInformation", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userData', {
  namespace: 'authentication'
})], PermissionMixin.prototype, "$userData", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isAdmin', {
  namespace: 'authentication'
})], PermissionMixin.prototype, "$isAdmin", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Action)('logOutUser', {
  namespace: 'authentication'
})], PermissionMixin.prototype, "$logOutUser", void 0);
exports.PermissionMixin = PermissionMixin = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], PermissionMixin);